import { render, staticRenderFns } from "./WorkerPage.vue?vue&type=template&id=73bca1d3&scoped=true&"
import script from "./WorkerPage.vue?vue&type=script&lang=js&"
export * from "./WorkerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bca1d3",
  null
  
)

export default component.exports